import { AddDeviceComponent } from "./add-device/add-device.component";
import { CloneNotificationSettingsDialogComponent } from "./clone-notification-settings-dialog/clone-notification-settings-dialog.component";
import { CommonModule } from "@angular/common";
import { ScrollingModule } from "@angular/cdk/scrolling";
import { ConfigureSensorDialogComponent } from "./configureSensorDialog/configureSensorDialog.component";
import { CreateDeviceVersionDialogComponent } from "./createDeviceVersionDialog/createDeviceVersionDialog.component";
import { CreateShadowConstraintDialogComponent } from "./createShadowConstraintDialog/createShadowConstraintDialog.component";
import { CreateTenantSensorDialogComponent } from "./createTenantSensorDialog/createTenantSensorDialog.component";
import { CreateUserDialogComponent } from "./createUserDialog/createUserDialog.component";
import { CustomFieldDialogModalComponent } from "./custom-field-dialog-modal/custom-field-dialog.component";
import { DeviceInfoComponent } from "./device-info/device-info.component";
import { EditCustomObjectDialogComponent } from "./editCustomObjectDialog/editCustomObjectDialog.component";
import { EditDeviceVersionDialogComponent } from "./editDeviceVersionDialog/editDeviceVersionDialog.component";
import { EditSensorDialogComponent } from "./editSensorDialog/editSensorDialog.component";
import { EditShadowConstraintDialogComponent } from "./editShadowConstraintDialog/editShadowConstraintDialog.component";
import { EditTenantSensorDialogComponent } from "./editTenantSensorDialog/editTenantSensorDialog.component";
import { EditUserDialogComponent } from "./editUserDialog/editUserDialog.component";
import { MfaDialogComponent } from "./mfaDialog/mfaDialog.component";
import { MultipleTaskAssignmentDialog } from "./multiple-task-assignment-dialog/multiple-task-assignment-dialog";
import { NgModule } from "@angular/core";
import { NodeAssignmentDialogComponent } from "./node-assignment-dialog/node-assignment-dialog.component";
import { NodeOperationsComponent } from "./node-operations/node-operations.component";
import { NotificationDialogComponent } from "./notification-dialog/notification-dialog.component";
import { SharedModule } from "../shared/shared.module";
import { SampleFilterDimensionComponent } from "../common-components/sample-filter-dimension/sample-filter-dimension.component";
import { TaskAssignmentDialogComponent } from "./task-assignment-dialog/task-assignment-dialog.component";
import { TenantUsersDialogComponent } from "./tenantUsersDialog/tenantUsersDialog.component";
import { TimeRangeDialogComponent } from "./timeRangeDialog/timeRangeDialog.component";
import { UploadLogoDialogComponent } from "./uploadLogoDialog/uploadLogoDialog.component";
import { UserDialogComponent } from "./user-dialog/user-dialog.component";
import { ZoneDialogComponent } from "./zone-dialog/zone-dialog.component";
import { CommonComponentsModule } from "../common-components/common-components.module";
import { DeviceCalibrationHistoryComponent } from "../components/device-calibration-history/device-calibration-history.component";
import { DeviceHistoryComponent } from "../components/device-history/device-history.component";
import { AssignNotificationSettingsDialogComponent } from "./assign-notification-settings-dialog/assign-notification-settings-dialog.component";
import { NotificationSettingsDialogComponent } from "./notification-settings-dialog/notification-settings-dialog.component";
import { DeleteDialog } from "../shared/delete-dialog/delete-dialog.component";
import { MultipleSensorAssignmentDialog } from "./node-assignment-dialog/multiple-sensor-assignment-dialog.component";
import { SegDialogComponent } from "./seg-dialog/seg-dialog.component";
import { PpeDialogComponent } from "./ppe-dialog/ppe-dialog.component";
import { ControlDialogComponent } from "./control-dialog/control-dialog.component";
import { ControlOrgLevelSegDialogComponent } from "./control-org-level-seg-dialog/control-org-level-seg-dialog.component";
import { LocationDialogComponent } from "./location-dialog/location-dialog.component";
import { TaskDialogComponent } from "./task-dialog/task-dialog.component";
import { LocationGroupDialog } from "./location-group-dialog/location-group-dialog.component";
import { TaskGroupAssignmentDialog } from "./task-group-assignment-dialog/task-group-assignment-dialog.component";
import { TaskGroupDialog } from "./task-group-dialog/task-group-dialog.component";
import { TaskSiteDialogComponent } from './task-site-dialog/task-site-dialog.component';
import { RiskAssessmentDialogComponent } from "./risk-assessment-dialog/risk-assessment-dialog.component";
import { ParameterDialogComponent } from "./parameter-dialog/parameter-dialog.component";
import { RiskRegisterDetailsPopupComponent } from "./risk-register-details-popup/risk-register-details-popup.component";
import { SampleGridViewDialogComponent } from './sample-grid-view-dialog/sample-grid-view-dialog.component';
import { AgentDialogComponent } from './agent-dialog/agent-dialog.component';
import { JurisdictionDialogComponent } from './jurisdiction-dialog/jurisdiction-dialog.component';
import { UserPreferencesDialogComponent } from "./user-preferences-dialog/user-preferences-dialog.component";
import { AccountSwitchComponent } from "./user-preferences-dialog/account-switch/account-switch.component";
import { AccountSegmentedControlComponent } from "./user-preferences-dialog/account-segmented-control/account-segmented-control.component";
import { AccountOtpInputComponent } from "./user-preferences-dialog/account-otp-input/account-otp-input.component";
import { AccountInlineEditChipComponent } from "./user-preferences-dialog/account-inline-edit-chip/account-inline-edit-chip.component";
import { AccountSubformShellComponent } from "./user-preferences-dialog/account-subform-shell/account-subform-shell.component";
import { AccountAlertsTabComponent } from "./user-preferences-dialog/account-alerts-tab/account-alerts-tab.component";
import { AccountRegionTabComponent } from "./user-preferences-dialog/account-region-tab/account-region-tab.component";
import { AccountUnitsTabComponent } from "./user-preferences-dialog/account-units-tab/account-units-tab.component";
import { AccountSecurityTabComponent } from "./user-preferences-dialog/account-security-tab/account-security-tab.component";
import { AccountSmsOptInComponent } from "./user-preferences-dialog/account-sms-opt-in/account-sms-opt-in.component";
import { AccountSmsVerifyComponent } from "./user-preferences-dialog/account-sms-verify/account-sms-verify.component";
import { AccountTwoFactorOtpComponent } from "./user-preferences-dialog/account-two-factor-otp/account-two-factor-otp.component";
import { AccountChangePasswordComponent } from "./user-preferences-dialog/account-change-password/account-change-password.component";
import { AccountIconComponent } from "./user-preferences-dialog/account-icon/account-icon.component";
import { EndDeviceAssignmentDialogComponent } from "./end-device-assignment-dialog/end-device-assignment-dialog.component";
import { AgentJurisdictionDialogComponent } from './agent-jurisdiction-dialog/agent-jurisdiction-dialog.component';
import { SegSiteDialogComponent } from './seg-site-dialog/seg-site-dialog.component';
import { SegOrgLevelDialogComponent } from './seg-org-level-dialog/seg-org-level-dialog.component';
import { SurveyDialogComponent } from './survey-dialog/survey-dialog.component';
import { SamplingEquipmentDialogComponent } from "./sampling-equipment-dialog/sampling-equipment-dialog.component";
import { CalibrationEquipmentDialogComponent } from './calibration-equipment-dialog/calibration-equipment-dialog.component';
import { AgentGroupDialogComponent } from './agent-group-dialog/agent-group-dialog.component';
import { GroupToAgentDialogComponent } from './group-to-agent-dialog/group-to-agent-dialog.component';
import { AgentToGroupDialogComponent } from "./agent-to-group-dialog/agent-to-group-dialog.component";
import { ControlToAgentDialogComponent } from './control-to-agent-dialog/control-to-agent-dialog.component';
import { SampleMediaDialogComponent } from './sample-media-dialog/sample-media-dialog.component';
import { AnalyticalMethodDialogComponent } from './analytical-method-dialog/analytical-method-dialog.component';
import { OrganizationLevelDialogComponent } from './organization-level-dialog/organization-level-dialog.component';
import { MediaToAnalyticalMethodDialogComponent } from "../media-to-analytical-method-dialog/media-to-analytical-method-dialog.component";
import { AttachmentsDialogComponent } from "./attachments-dialog/attachments-dialog.component";
import { LabResultImportDialogComponent } from "./lab-result-import-dialog/lab-result-import-dialog.component";
import { TranslateModule } from "@ngx-translate/core";
import { LabResultsDialogComponent } from './lab-results-dialog/lab-results-dialog.component';
import { OelTypeDialogComponent } from './oel-type-dialog/oel-type-dialog.component';
import { LabIntegrationDialogComponent } from "./lab-integration-dialog/lab-integration-dialog.component";
import { TurnAroundTimeDialogComponent } from './turn-around-time-dialog/turn-around-time-dialog.component';
import { SampleDialogComponent } from './sample-dialog/sample-dialog.component';
import { ConfirmLeaveDialogComponent } from "./confirm-leave-dialog/confirm-leave-dialog.component";
import { VoidReasonDialogComponent } from './void-reason-dialog/void-reason-dialog.component';
import { OutlierReasonDialogComponent } from './outlier-reason-dialog/outlier-reason-dialog.component';
import { CalDriftWarningDialogComponent } from './cal-drift-warning-dialog/cal-drift-warning-dialog.component';
import { CalibrationDialogComponent } from "./calibration-dialog/calibration-dialog.component";
import { SendEmailDialogComponent } from './send-email-dialog/send-email-dialog.component';
import { LinkControlDialogComponent } from './link-control-dialog/link-control-dialog.component';
import { RichTextEditorComponent } from '../shared/rich-text-editor/rich-text-editor.component';
import { AgentSiteDialogComponent } from "./agent-site-dialog/agent-site-dialog.component";
import { ShiftDialogComponent } from "./shift-dialog/shift-dialog.component";
import { BulkDeleteConfirmationDialogComponent } from "./bulk-delete-confirmation-dialog/bulk-delete-confirmation-dialog.component";
import { EvidencePackDialogComponent } from "./evidence-pack-dialog/evidence-pack-dialog.component";
import { UnlinkCocDialogComponent } from "./unlink-coc-dialog/unlink-coc-dialog.component";
import { ParameterDeleteBlockedDialogComponent } from "./parameter-delete-blocked-dialog/parameter-delete-blocked-dialog.component";
import { BulkEditSamplesDialogComponent } from "./bulk-edit-samples-dialog/bulk-edit-samples-dialog.component";
import { OrgTreeSelectComponent } from "../shared/org-tree-select/org-tree-select.component";
import { SegSamplingPlanDialogComponent } from "./seg-sampling-plan-dialog/seg-sampling-plan-dialog.component";
import { SamplingPlanDialogComponent } from "./sampling-plan-dialog/sampling-plan-dialog.component";
import { SegDeleteMergeDialogComponent } from "./seg-delete-merge-dialog/seg-delete-merge-dialog.component";
import { RiskRegisterBulkResultDialogComponent } from "./risk-register-bulk-result-dialog/risk-register-bulk-result-dialog.component";
import { BulkCalDriftWarningDialogComponent } from "./bulk-cal-drift-warning-dialog/bulk-cal-drift-warning-dialog.component";

@NgModule({
    declarations: [
        ZoneDialogComponent,
        UserDialogComponent,
        UploadLogoDialogComponent,
        TimeRangeDialogComponent,
        TenantUsersDialogComponent,
        TaskAssignmentDialogComponent,
        NotificationDialogComponent,
        NodeOperationsComponent,
        NodeAssignmentDialogComponent,
        MultipleTaskAssignmentDialog,
        MfaDialogComponent,
        EditUserDialogComponent,
        EditTenantSensorDialogComponent,
        EditShadowConstraintDialogComponent,
        EditSensorDialogComponent,
        EditDeviceVersionDialogComponent,
        EditCustomObjectDialogComponent,
        DeviceInfoComponent,
        CustomFieldDialogModalComponent,
        CreateUserDialogComponent,
        CreateTenantSensorDialogComponent,
        CreateShadowConstraintDialogComponent,
        CreateDeviceVersionDialogComponent,
        ConfigureSensorDialogComponent,
        CloneNotificationSettingsDialogComponent,
        AddDeviceComponent,
        CreateTenantSensorDialogComponent,
        EditTenantSensorDialogComponent,
        ConfigureSensorDialogComponent,
        DeviceHistoryComponent,
        DeviceCalibrationHistoryComponent,
        AssignNotificationSettingsDialogComponent,
        NotificationSettingsDialogComponent,
        DeleteDialog,
        MultipleSensorAssignmentDialog,
        SegDialogComponent,
        PpeDialogComponent,
        LocationDialogComponent,
        TaskDialogComponent,
        LocationGroupDialog,
        TaskGroupAssignmentDialog,
        TaskGroupDialog,
        TaskSiteDialogComponent,
        RiskAssessmentDialogComponent,
        RiskRegisterDetailsPopupComponent,
        UserPreferencesDialogComponent,
        SampleGridViewDialogComponent,
        AgentDialogComponent,
        JurisdictionDialogComponent,
        EndDeviceAssignmentDialogComponent,
        AgentJurisdictionDialogComponent,
        SegSiteDialogComponent,
        SegOrgLevelDialogComponent,
        SurveyDialogComponent,
        SamplingEquipmentDialogComponent,
        CalibrationEquipmentDialogComponent,
        SampleMediaDialogComponent,
        AnalyticalMethodDialogComponent,
        OrganizationLevelDialogComponent,
        AttachmentsDialogComponent,
        LabResultImportDialogComponent,
        AgentGroupDialogComponent,
        GroupToAgentDialogComponent,
        AgentToGroupDialogComponent,
        ControlToAgentDialogComponent,
        MediaToAnalyticalMethodDialogComponent,
        LabResultsDialogComponent,
        OelTypeDialogComponent,
        LabIntegrationDialogComponent,
        TurnAroundTimeDialogComponent,
        SampleDialogComponent,
        ConfirmLeaveDialogComponent,
        VoidReasonDialogComponent,
        OutlierReasonDialogComponent,
        CalDriftWarningDialogComponent,
        CalibrationDialogComponent,
        SendEmailDialogComponent,
        ControlDialogComponent,
        ControlOrgLevelSegDialogComponent,
        LinkControlDialogComponent,
        AgentSiteDialogComponent,
        ShiftDialogComponent,
        BulkDeleteConfirmationDialogComponent,
        EvidencePackDialogComponent,
        UnlinkCocDialogComponent,
        ParameterDialogComponent,
        ParameterDeleteBlockedDialogComponent,
        BulkEditSamplesDialogComponent,
        SegSamplingPlanDialogComponent,
        SamplingPlanDialogComponent,
        SegDeleteMergeDialogComponent,
        AccountSwitchComponent,
        AccountSegmentedControlComponent,
        AccountOtpInputComponent,
        AccountInlineEditChipComponent,
        AccountSubformShellComponent,
        AccountAlertsTabComponent,
        AccountRegionTabComponent,
        AccountUnitsTabComponent,
        AccountSecurityTabComponent,
        AccountSmsOptInComponent,
        AccountSmsVerifyComponent,
        AccountTwoFactorOtpComponent,
        AccountChangePasswordComponent,
        AccountIconComponent,
        RiskRegisterBulkResultDialogComponent,
        BulkCalDriftWarningDialogComponent
    ],
    imports: [CommonModule, SharedModule, CommonComponentsModule, TranslateModule, RichTextEditorComponent, OrgTreeSelectComponent, SampleFilterDimensionComponent, ScrollingModule],
    exports: [
        ZoneDialogComponent,
        UserDialogComponent,
        UploadLogoDialogComponent,
        TimeRangeDialogComponent,
        TenantUsersDialogComponent,
        TaskAssignmentDialogComponent,
        NotificationDialogComponent,
        NodeOperationsComponent,
        NodeAssignmentDialogComponent,
        MultipleTaskAssignmentDialog,
        MfaDialogComponent,
        EditUserDialogComponent,
        EditTenantSensorDialogComponent,
        EditShadowConstraintDialogComponent,
        EditSensorDialogComponent,
        EditDeviceVersionDialogComponent,
        EditCustomObjectDialogComponent,
        DeviceInfoComponent,
        CustomFieldDialogModalComponent,
        CreateUserDialogComponent,
        CreateTenantSensorDialogComponent,
        CreateShadowConstraintDialogComponent,
        CreateDeviceVersionDialogComponent,
        ConfigureSensorDialogComponent,
        CloneNotificationSettingsDialogComponent,
        AddDeviceComponent,
        CreateTenantSensorDialogComponent,
        EditTenantSensorDialogComponent,
        ConfigureSensorDialogComponent,
        AssignNotificationSettingsDialogComponent,
        NotificationSettingsDialogComponent,
        DeleteDialog,
        MultipleSensorAssignmentDialog,
        SegDialogComponent,
        PpeDialogComponent,
        LocationDialogComponent,
        TaskDialogComponent,
        LocationGroupDialog,
        TaskGroupAssignmentDialog,
        TaskGroupDialog,
        TaskSiteDialogComponent,
        RiskAssessmentDialogComponent,
        RiskRegisterDetailsPopupComponent,
        UserPreferencesDialogComponent,
        SampleGridViewDialogComponent,
        AgentDialogComponent,
        JurisdictionDialogComponent,
        EndDeviceAssignmentDialogComponent,
        AgentJurisdictionDialogComponent,
        SegSiteDialogComponent,
        SegOrgLevelDialogComponent,
        SurveyDialogComponent,
        SamplingEquipmentDialogComponent,
        CalibrationEquipmentDialogComponent,
        GroupToAgentDialogComponent,
        AgentToGroupDialogComponent,
        ControlToAgentDialogComponent,
        SampleMediaDialogComponent,
        AnalyticalMethodDialogComponent,
        OrganizationLevelDialogComponent,
        MediaToAnalyticalMethodDialogComponent,
        AttachmentsDialogComponent,
        LabResultImportDialogComponent,
        LabResultsDialogComponent,
        OelTypeDialogComponent,
        LabIntegrationDialogComponent,
        TurnAroundTimeDialogComponent,
        SampleDialogComponent,
        ConfirmLeaveDialogComponent,
        VoidReasonDialogComponent,
        OutlierReasonDialogComponent,
        CalDriftWarningDialogComponent,
        CalibrationDialogComponent,
        SendEmailDialogComponent,
        ControlDialogComponent,
        ControlOrgLevelSegDialogComponent,
        LinkControlDialogComponent,
        AgentSiteDialogComponent,
        ShiftDialogComponent,
        BulkDeleteConfirmationDialogComponent,
        EvidencePackDialogComponent,
        UnlinkCocDialogComponent,
        ParameterDialogComponent,
        ParameterDeleteBlockedDialogComponent,
        BulkEditSamplesDialogComponent,
        SegSamplingPlanDialogComponent,
        SamplingPlanDialogComponent,
        SegDeleteMergeDialogComponent,
        RiskRegisterBulkResultDialogComponent,
        BulkCalDriftWarningDialogComponent
    ],
})
export class DialogModalsModule { }
